import React, { useState } from 'react'
import { useQuery, useMutation } from 'react-apollo-hooks'
import { Text } from 'rebass'
import get from 'lodash.get'

import {
  Form,
  TextInput,
  InputGroup,
  FormSection,
} from '../Form'
import Card from '../Card'
import Loading from '../Loading'

import { updateGeneralSchema } from '../../utilities/validations'
import queries from '../../queries'
import mutations from '../../mutations'

const Profile = () => {
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const { data, error: queryError, loading } = useQuery(queries.users.PROFILE, {
    suspend: false,
    fetchPolicy: 'network-only',
  })
  const updateProfile = useMutation(mutations.users.GENERAL)

  const onSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true)
    setError(null)
    setSuccess(null)

    const variables = {
      ...updateGeneralSchema.cast(values),
      id: get(data, 'me.id', ''),
    }

    try {
      await updateProfile({ variables })
      setSuccess('Your account was updated')
    } catch (e) {
      setError(e.message)
    }

    setSubmitting(false)
  }

  if (queryError && queryError.message) return <Text color="error">{queryError.message}</Text>

  return (
    <Card
      heading="General information"
    >
      {loading
        ? <Loading />
        : (
          <Form
            initialValues={{
              firstName: get(data, 'me.firstName', ''),
              lastName: get(data, 'me.lastName', ''),
            }}
            validationSchema={updateGeneralSchema}
            onSubmit={onSubmit}
            success={success}
            error={error}
          >
            <FormSection>
              <InputGroup>
                <TextInput name="firstName" placeholder="First name" label="First name" />
                <TextInput name="lastName" placeholder="Last name" label="Last name" />
              </InputGroup>
            </FormSection>
          </Form>
        )
      }
    </Card>
  )
}

export default Profile
